import Api from "../api.jsx";

export const authUrl = "auth/";

class AuthApi extends Api {
	
	createSession(email, password, callback) {
	    var url = this.baseUrl + authUrl;

	    let credentials = { 'email': email, 'password': password }
	     
	    return this.client.post(url, credentials).then((response) => {
	    	return callback({ 
	    		result: response.data, 
	    		error: null
	    	});
	    }).catch((error) => {
	    	callback({ 
	    		result: null, 
	    		error: this.extractError(error)
	    	});
	    });
	}
}

export default AuthApi;